<template>
  <div>
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <!--<img src="@/assets/img/back.png" alt="">-->
        <span style="color: #FFFFFF">消息</span>
      </p>
    </header>
    <div style="margin: 70px 0">
      <van-tabs v-model="activeName" @click="getMessager">
        <van-tab title="已投递" name="1">
          <div v-if="list" class="messageCenter" v-for="(index,key) in list" @click="goto">
            <div class="communicate">
              <img v-if="index.logo" :src="index.logo" alt="">
              <img v-else="" src="@/assets/img/2.jpg" alt="">

            </div>
            <div style="width: 78%;padding-left: 14px" class="">
              <!--<div><span style="color:#639DD5">韩多多</span><span style="color:#BEBEBE;margin-left: 1rem;font-size: 12px ">十二栋</span></div>-->
              <div class="communicateTop">
                <span style="color:#639DD5">{{index.job_name}}</span>
                <span style="float: right;font-size: 15px">{{index.create_time}}</span>
              </div>
              <div class="communicateRight">
                <span > {{index.city}}</span>
                <span > {{"|&nbsp;&nbsp;"+ index.company_name}}</span>
              </div>
              <div class="communicateRight">
                <span v-if="index.salary==1"> 1K-2K</span>
                <span v-else-if="index.salary==2"> 2K-4K</span>
                <span v-else-if="index.salary==3"> 4K-6K</span>
                <span v-else-if="index.salary==4"> 6K-8K</span>
                <span v-else-if="index.salary==5"> 8K-10K</span>
                <span v-else-if="index.salary==6"> 10K-15K</span>
                <span v-else-if="index.salary==7"> 15K-20K</span>
                <span v-else-if="index.salary==8"> 20K-25K</span>
                <span v-else-if="index.salary==9"> 25K-35K</span>
                <span v-else-if="index.salary==10"> 23K-50K</span>
                <span v-else-if="index.salary==11"> 50K-70K</span>
                <span v-else-if="index.salary==12"> 70K-100K</span>
                <span v-else-if="index.salary==13"> 100K以上</span>
              </div>

            </div>
          </div>
        </van-tab>
        <van-tab title="被查看" name="2">
          <div v-if="list" class="messageCenter" v-for="(index,key) in list">
            <div class="communicate">
              <img v-if="index.logo" :src="index.logo" alt="">
              <img v-else="" src="@/assets/img/2.jpg" alt="">

            </div>
            <div style="width: 78%;padding-left: 14px" class="">
              <!--<div><span style="color:#639DD5">韩多多</span><span style="color:#BEBEBE;margin-left: 1rem;font-size: 12px ">十二栋</span></div>-->
              <div class="communicateTop">
                <span style="color:#639DD5">{{index.job_name}}</span>
                <span style="float: right">{{index.create_time}}</span>
              </div>
              <div class="communicateRight">
                <span > {{index.city}}</span>
                <span > {{"|&nbsp;&nbsp;"+ index.company_name}}</span>
              </div>
              <div class="communicateRight">
                <span v-if="index.salary==1"> 1K-2K</span>
                <span v-else-if="index.salary==2"> 2K-4K</span>
                <span v-else-if="index.salary==3"> 4K-6K</span>
                <span v-else-if="index.salary==4"> 6K-8K</span>
                <span v-else-if="index.salary==5"> 8K-10K</span>
                <span v-else-if="index.salary==6"> 10K-15K</span>
                <span v-else-if="index.salary==7"> 15K-20K</span>
                <span v-else-if="index.salary==8"> 20K-25K</span>
                <span v-else-if="index.salary==9"> 25K-35K</span>
                <span v-else-if="index.salary==10"> 23K-50K</span>
                <span v-else-if="index.salary==11"> 50K-70K</span>
                <span v-else-if="index.salary==12"> 70K-100K</span>
                <span v-else-if="index.salary==13"> 100K以上</span>
              </div>

            </div>
          </div>
        </van-tab>
        <van-tab title="待沟通" name="3"></van-tab>
        <van-tab title="面试" name="4"></van-tab>
        <van-tab title="不合适" name="5"></van-tab>
      </van-tabs>
    </div>
    <van-tabbar route v-model="active">
      <van-tabbar-item replace to="/" icon="wap-home-o">
        首页
      </van-tabbar-item>
      <van-tabbar-item replace to="/position" icon="envelop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace @click="href()" icon="fire-o">
        <!--<van-icon name="fire-o" />-->
        社保
      </van-tabbar-item>
      <van-tabbar-item replace to="/firstMessage" icon="desktop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/HelloWorld" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
        activeName: 1,
        active:0,
        list:{},
        list2:{}
      }
    },
    mounted(){
      this.getMessager()
//      this.getMessager1()
    },
    methods:{
      href(){
        window.location.href = 'https://m.shangshebao.com';
      },
      backHistory(){
        this.$router.go(-1)
      },
      goto(){
        this.$router.push("/firstMessageDetail")
      },
      getMessager(){ //职位信息
        this.$api.getMessage({
          "user_id":localStorage.getItem("userid"),
          "type":this.activeName
        })
          .then(res=>{
//            if(res.status==200){
            this.list=res.data
          })
      },
      getMessager1(){ //职位信息
//        this.$api.getComPosition({
//           "jobid":4
//        })
//          .then(res=>{
////            if(res.status==200){
//            this.list=res.data
//          })
      },

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  .headerSpan{
    margin-left: 1rem;
    line-height: 10px;
    color: #FFFFFF;
  }
  header{
    width: 100%;
    height: 56px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .messageHeader{
    width: 100%;
    background-color: #6e9bcf;
    position: fixed;
    top:0;
  }
  .messageTopDiv{
    display: flex;
    justify-content: space-around;
    margin-top: 2rem;
  }
  .messageTop{
    /*width: 15%;*/
    text-align: center;
    color: #FFFFFF;
  }
  .messageClear{
    color: #FFFFFF;
    /*width: 39%;*/
    text-align: center;
    /*text-align: center;*/
    display: flex;
    align-items: center;
    /*justify-content: center*/
  }
  .messageCenter{
    /*margin-top: 75px;*/
    display: flex;
    align-items: center;
    width: 85%;
    margin: auto;
    padding-top: 2rem;
  }
  .communicate{
    width: 50px;
    height: 50px;
    /*border-radius:100% ;*/
  }
  .communicate img{
    width: 100%;
    /*width: 100%;*/
    border-radius: 100%;
  }
  .communicateRight{
    /*display: flex;*/
    /*display: flex;*/
    /*justify-content: space-between;*/
    padding-top: 6px;
    font-size: 12px;
    color: #8f8f94;
  }
  .communicateTop{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/firstMessage.vue